<template>
  <div>
    <a-form-model
      :model="form"
      :label-col="labelCol"
      :wrapper-col="wrapperCol"
      style="margin-top: 10px;"
      :rules="rules"
      ref="ruleForm"
    >
      <a-form-model-item label="Chọn nhân viên" prop="employeeId">
        <SelectEmployee
          v-model="form.employeeId"
          :selectProps="{
            placeholder: 'Chọn nhân viên',
          }"
        />
      </a-form-model-item>
      <a-form-model-item label="Ngày bắt đầu" prop="startDate">
        <a-date-picker
          type="startDate"
          placeholder="Chọn ngày bắt đầu"
          style="width: 100%;"
          v-model="form.startDate"
        />
      </a-form-model-item>
      <a-form-model-item label="Ngày kết thúc" prop="endDate">
        <a-date-picker
          type="date"
          placeholder="Chọn ngày kết thúc"
          style="width: 100%;"
          v-model="form.endDate"
        />
      </a-form-model-item>
      <a-form-model-item label="Số ngày công tác" prop="totalLeaveDays">
        <a-input-number
          v-model="form.totalLeaveDays"
          placeholder="Số ngày công tác..."
          :formatter="
            (value) =>
              +value >= 0
                ? `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')
                : undefined
          "
          :parser="(value) => value.replace(/\$\s?|(,*)/g, '')"
          style="width: 100%;"
        />
      </a-form-model-item>
    </a-form-model>
    <div
      :style="{
        position: 'absolute',
        right: 0,
        bottom: 0,
        width: '100%',
        borderTop: '1px solid #e9e9e9',
        padding: '10px 16px',
        background: '#fff',
        textAlign: 'right',
        zIndex: 1,
      }"
    >
      <a-button style="margin-right: 10px;" @click="close">
        Đóng
      </a-button>
      <a-button type="primary" @click="onSubmit" :loading="loading">
        Thêm mới
      </a-button>
    </div>
  </div>
</template>
<script>
import query from "../constant/query";
import SelectEmployee from "@/components/common/employee/select";

const rules = {
  employeeId: [{ required: true, message: "Thông tin không được bỏ trống" }],
  startDate: [{ required: true, message: "Thông tin không được bỏ trống" }],
  endDate: [{ required: true, message: "Thông tin không được bỏ trống" }],
};
const defaultForm = { status: "ACTIVE" };
export default {
  components: { SelectEmployee },
  props: {
    close: { type: Function, required: true },
    refreshAfterCreated: { type: Function, required: true },
  },
  data() {
    return {
      rules,
      labelCol: { span: 24 },
      wrapperCol: { span: 24 },
      form: { status: "ACTIVE" },
      loading: false,
    };
  },
  methods: {
    onSubmit() {
      this.$refs.ruleForm.validate((valid) => {
        if (valid) {
          this.onCreateData();
        } else {
          return false;
        }
      });
    },
    onCreateData() {
      this.loading = true;
      this.$apollo
        .mutate({
          mutation: query.createOnBusiness,
          variables: {
            ...this.form,
          },
        })
        .then(({ data }) => {
          this.$notification.success({
            message: "Thông báo",
            description: "Thêm thành công!",
          });
          this.loading = false;
          this.form = { ...defaultForm };
          if (data?.createOnBusiness?.id) {
            this.refreshAfterCreated(data.createOnBusiness);
          }
        })
        .catch((err) => {
          this.loading = false;
          this.$notification.error({
            message: "Thông báo",
            description: "Thêm không thành công!",
          });
          console.log("Thêm không thành công", err);
        });
    },
  },
};
</script>
<style scoped>
.ict24h-editor >>> .ql-toolbar.ql-snow {
  padding: 2px !important;
}
</style>
